Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "Widget180168712",
  {"root":"Widget180168712--root"},
  "",
  10,
  "Widget180168712"
);

